import React from 'react';
import { FormattedMessage } from 'react-intl';
import { FIRMWARE_STATUS } from '../../config/devices';
import DevicesInfoChip from '../DevicesInfoChip';
import messages from './messages';

export interface IFirmwareStatusProps {
  status: string;
  text?: React.ReactNode;
}

export function FirmwareStatus({ status, text = null }: IFirmwareStatusProps) {
  let styles = {};
  if (status === FIRMWARE_STATUS.UNSUPPORTED) {
    styles = 'error';
  } else if (status === FIRMWARE_STATUS.DEPRECATED) {
    styles = 'warning';
  }

  return (
    <DevicesInfoChip
      error={styles === 'error'}
      label={text || <FormattedMessage {...firmwareStatusMap[status]} />}
      size="small"
      variant="outlined"
      warning={styles === 'warning'}
    />
  );
}

const firmwareStatusMap = {
  [FIRMWARE_STATUS.DEPRECATED]: messages.firmwareStatusFirmwareStatusDeprecated,
  [FIRMWARE_STATUS.UNSUPPORTED]: messages.firmwareStatusFirmwareStatusUnsupported,
};
